import React from "react";
import { Card, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { url_reverse } from "@components/Utils";

export default function ApkUpload({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:apk_upload", { game_id: gameId }));
    const gameCommonInfo = useRouteLoaderData("gameCommonInfo");

    if (!apiData) return;

    return (
        <>
            <Card>
                <Card.Header>{header}</Card.Header>
                <Card.Body>
                    <RenderForm />
                    <div className="dmg-callout dmg-callout-info mt-4">
                        <div>
                            {t("Необходим секрет из поля")} <strong>{t("Секрет для API игр")}</strong>
                        </div>
                        curl -u {gameCommonInfo.game.id}:{gameCommonInfo.game.api_secret}{" "}
                        https://api.vkplay.ru/play/games/apk_upload/ -F apk=<strong style={{ color: "red" }}>@</strong>
                        path_to.apk -F apk_for_dev=1 -F version=v0.0.1 -F email=test@test.ru
                    </div>
                </Card.Body>
            </Card>
            {apiData.object_list?.length > 0 && (
                <Card className="mt-3">
                    <Card.Header>{t("Загруженные APK")}</Card.Header>
                    <Card.Body>
                        <Table hover responsive className="dmg-table">
                            <thead>
                                <tr>
                                    <th>{t("Внутренняя версия")}</th>
                                    <th>{t("Версия")}</th>
                                    <th>{t("Дата создания")}</th>
                                    <th>{t("Размер")}</th>
                                    <th>{t("Автор")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {apiData.object_list?.map((o, i) => {
                                    return (
                                        <tr key={`object_list${i}`}>
                                            <td>{o.internal_version}</td>
                                            <td>{o.version}</td>
                                            <td>{o.date_added}</td>
                                            <td>{o.readable_size}</td>
                                            <td>{o.author_or_api}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            )}
        </>
    );
}
